import { render } from "./DirectMember.vue?vue&type=template&id=1c1aba36&scoped=true"
import script from "./DirectMember.vue?vue&type=script&lang=js"
export * from "./DirectMember.vue?vue&type=script&lang=js"

import "./DirectMember.vue?vue&type=style&index=0&id=1c1aba36&lang=stylus&scoped=true"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1aba36"]])

export default __exports__